import { useEffect, useState } from 'react';
import { Alert, Box, Button, TextField } from '@mui/material';
import { TabContext } from '@mui/lab';
import { StyledTabPanel } from 'shared/styles/StyledTabs';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import {
  useResetPasswordDataMutation,
  useSetPasswordDataMutation,
} from 'features/changeUserData/api/resetPasswordDataApi';
import { UserProfileType } from 'entities/user/model/types';

type ResetPasswordProps = {
  profile: UserProfileType;
  app_type: string;
};

type FormDataType = {
  reason: string;
};

export const ResetPassword = ({ profile }: ResetPasswordProps) => {
  const [resetPasswordData, { isLoading: isResetPasswordDataLoading, isSuccess: isResetPasswordSuccess }] =
    useResetPasswordDataMutation();
  const [setPasswordData, { isLoading: isSetPasswordData }] = useSetPasswordDataMutation();
  const [showForm, setShowForm] = useState('reset-password');
  const [tab] = useState('0');

  const {
    control,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      reason: '',
    },
  });
  const { control: controlPassword, handleSubmit: handleSubmitPassword } = useForm<any>({
    defaultValues: {
      password: '',
    },
  });

  const onFormSubmit: SubmitHandler<FormDataType> = ({ reason }) => {
    resetPasswordData({ id: profile.id, body: { reason } });
  };

  const onPasswordFormSubmit: SubmitHandler<any> = ({ password }) => {
    setPasswordData({ id: profile.id, body: { new_password: password } });
  };
  useEffect(() => {
    if (isResetPasswordSuccess) {
      setShowForm('set-password');
    }
  }, [isResetPasswordSuccess]);
  return (
    <TabContext value={tab}>
      <StyledTabPanel value="0">
        {showForm === 'reset-password' && (
          <Box
            component="form"
            onSubmit={handleSubmit(onFormSubmit)}
          >
            <Controller
              name="reason"
              control={control}
              rules={{
                required: 'Причина сброса пароля обязательна',
              }}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Причина сброса пароля"
                  placeholder=""
                  fullWidth
                  size="small"
                  disabled={isResetPasswordDataLoading}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.reason && true}
                  {...field}
                />
              )}
            />
            <p className="title">К примечанию о сбросе пароля будет добавлен ваш комментарий и подпись.</p>
            <Alert
              variant="outlined"
              severity="warning"
              className="worningAlert"
            >
              Приложение автоматически выключит аккаунт пользователя. Пользователь сам заменит свой пароль при новом
              входе в приложение. Для этого ему потребуется ввести код из SMS-сообщения
            </Alert>
            <Button
              type="submit"
              variant="contained"
              disabled={isResetPasswordDataLoading}
              sx={{ textTransform: 'none' }}
            >
              Сбросить пароль
            </Button>
          </Box>
        )}
        {showForm === 'set-password' && (
          <Box
            component="form"
            onSubmit={handleSubmitPassword(onPasswordFormSubmit)}
          >
            <Controller
              name="password"
              control={controlPassword}
              rules={{
                required: 'password',
              }}
              render={({ field }) => (
                <TextField
                  type="password"
                  label="Новый пароль"
                  placeholder=""
                  fullWidth
                  size="small"
                  disabled={isSetPasswordData}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.reason && true}
                  {...field}
                />
              )}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={isSetPasswordData}
              sx={{ textTransform: 'none' }}
            >
              Сбросить пароль
            </Button>
          </Box>
        )}
      </StyledTabPanel>
      <StyledTabPanel value="1" />
    </TabContext>
  );
};
